import React from 'react';
import { Modal, Field } from './ui';

// Desktop add/edit form modal for the field-driven CRUD folders (functions /
// guests). THREE tight columns, not two roomy ones: a date or a time needs
// ~150px, so a half-width field in a 560px dialog was mostly empty space and
// pushed the rest of the form below the fold. `half` = one column, `span: n`
// widens a field, anything else takes the whole row. Reads the useCrudList `vm`.
export default function CrudFormModalDesktop({ vm, title }) {
  const { editing, values, fields, saving, setField, save, closeForm } = vm;
  if (!vm.open) return null;
  return (
    <Modal
      wide dense className="crud-form-modal"
      title={`${editing ? 'Edit' : 'Add'} ${title}`}
      onClose={closeForm}
      footer={<>
        <button className="btn light" onClick={closeForm}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving…' : 'Save'}</button>
      </>}
    >
      <div className="form-grid cols-3">
        {fields.map(f => (
          <div key={f.key} style={{ gridColumn: f.span ? `span ${f.span}` : (f.half ? 'auto' : '1 / -1') }}>
            <Field
              label={f.label} type={f.type || 'text'} value={values[f.key]}
              options={f.options} required={f.required} rows={f.rows}
              onChange={(v) => setField(f, v)}
            />
          </div>
        ))}
      </div>
    </Modal>
  );
}
